import { ButtonUnstyled, ContainerAtom } from "../../atoms";
import styles from "./styles.module.scss";

interface Props {
  steps: string[];
  currentStep: number;
  completedSteps: number[];
  onClick: (index: number) => void;
}

export function StepperMolecule(props: Readonly<Props>) {
  const stepitem = (step: string, index: number) => {
    const active = props.currentStep === index;
    const completed = props.completedSteps.includes(index);
    let className = "";
    if (active) className += `${styles.is_active}`;

    return (
      <li key={step} className={className} aria-current={active ? "true" : undefined}>
        {completed && (
          <ButtonUnstyled id={step} onClick={() => completed && props.onClick(index)}>
            {active && <span hidden>Huidige stap: </span>}
            {completed && <span hidden>Afgeronde stap: </span>}
            <u>{step}</u>
          </ButtonUnstyled>
        )}
        {!completed && <em>{step}</em>}
      </li>
    );
  };

  return (
    <ContainerAtom centeredHorizontal>
      <ol className={styles.steps} aria-label="Voortgang (stappen)">
        {props.steps.map((step: string, index: number) => stepitem(step, index))}
      </ol>
    </ContainerAtom>
  );
}
